import { render, staticRenderFns } from "./topicHeader.vue?vue&type=template&id=50eed2b2&scoped=true&"
import script from "./topicHeader.vue?vue&type=script&lang=js&"
export * from "./topicHeader.vue?vue&type=script&lang=js&"
import style0 from "./topicHeader.vue?vue&type=style&index=0&id=50eed2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eed2b2",
  null
  
)

export default component.exports